import { AscendingOrderArray, type Status, TIME_FRAME } from "@packages/core";
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  ResponsiveContainerProps,
  XAxis,
  YAxis,
} from "recharts";
import { Temporal } from "temporal-polyfill";
import { type Merge } from "type-fest";
import { renderStatusChart } from "../../services";

export type StatusBarThumbnailProperties = Merge<
  ResponsiveContainerProps,
  {
    children?: never;
    className?: string;
    /** **簡単モード** `true`の時、いくつかの入居者状態にそれぞれ同じ色を割り当てる。 */
    easy?: boolean;
    date: Temporal.PlainDate;
    statuses: AscendingOrderArray<Pick<Status, "state" | "transitionedAt">>;
  }
>;

export function StatusBarThumbnail({
  className,
  date,
  easy,
  height,
  statuses,
  width,
  ...properties
}: StatusBarThumbnailProperties) {
  const c = (
    <BarChart
      barCategoryGap={0}
      barGap={0}
      className={className}
      data={[{ x: 24, y: 0 }]}
      height={typeof height === "number" ? height : undefined}
      layout="vertical"
      margin={{ bottom: 0, left: 0, right: 0, top: 0 }}
      width={typeof width === "number" ? width : undefined}
    >
      <XAxis
        allowDataOverflow
        axisLine={false}
        dataKey="x"
        height={0}
        tick={false}
        tickLine={false}
        type="number"
      />
      <YAxis axisLine={false} dataKey="y" tick={false} tickLine={false} type="category" width={0} />
      <Bar
        dataKey="x"
        fill="#0000"
        label={function ({ height, width, x, y }) {
          if (typeof width !== "number") {
            return;
          }

          return (
            <image
              height={height}
              href={renderStatusChart(
                {
                  from: date.toPlainDateTime({ hour: TIME_FRAME.DAYTIME[0] }),
                  numberOfPixels: width,
                  statuses,
                  to: date.add({ days: 1 }).toPlainDateTime({ hour: TIME_FRAME.DAYTIME[0] }),
                },
                { easy },
              ).toDataURL()}
              preserveAspectRatio="none"
              width={width}
              x={x}
              y={y}
            />
          );
        }}
      />
    </BarChart>
  );

  if (typeof height === "number" && typeof width === "number") {
    return c;
  } else {
    return (
      <ResponsiveContainer height={height} width={width} {...properties} className={className}>
        {c}
      </ResponsiveContainer>
    );
  }
}
